var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5213 0.481729C19.3054 0.26683 19.0346 0.115757 18.7386 0.0451129C18.4427 -0.0255311 18.133 -0.0130116 17.8437 0.0812955L1.147 5.66448C0.837341 5.76284 0.563706 5.951 0.360655 6.20517C0.157603 6.45935 0.0342435 6.76814 0.00615618 7.09256C-0.0219312 7.41698 0.0465136 7.74247 0.202846 8.02791C0.359179 8.31336 0.596386 8.54596 0.884509 8.69633L7.81197 12.1286L11.2358 19.0962C11.3734 19.3689 11.584 19.5979 11.8439 19.7575C12.1039 19.9171 12.4031 20.0011 12.708 20H12.8221C13.1486 19.9759 13.4603 19.8539 13.7168 19.6499C13.9732 19.4458 14.1625 19.1692 14.2601 18.8559L19.9093 2.16355C20.0102 1.87516 20.0273 1.56398 19.9586 1.26623C19.8899 0.968485 19.7383 0.696427 19.5213 0.481729ZM1.85458 7.24333L16.4285 2.36949L8.33695 10.4811L1.85458 7.24333ZM12.7879 18.1923L9.54669 11.6939L17.6382 3.58223L12.7879 18.1923Z",
    fill: "#ABB1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSend);
export default __webpack_public_path__ + "static/media/comment_send.adc536158ab342f6817ec019f5aeb481.svg";
export { ForwardRef as ReactComponent };